var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.223858 2 0 2.22386 0 2.5C0 2.77614 0.223858 3 0.5 3H15.5C15.7761 3 16 2.77614 16 2.5C16 2.22386 15.7761 2 15.5 2H0.5ZM1.16692 5.14431C1.07894 4.54097 1.54673 4 2.15646 4H13.8436C14.4534 4 14.9212 4.54096 14.8332 5.14431L13.3748 15.1443C13.3032 15.6357 12.8818 16 12.3853 16H3.61479C3.11825 16 2.69691 15.6357 2.62526 15.1443L1.16692 5.14431ZM1.99991 5H13.9999L12.3636 15H3.63629L1.99991 5ZM6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5V12.5C7 12.7761 6.77614 13 6.5 13C6.22386 13 6 12.7761 6 12.5V7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V7.5C10 7.22386 9.77614 7 9.5 7Z",
    fill: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C4.89543 0 4 0.895431 4 2H5C5 1.44772 5.44772 1 6 1H10C10.5523 1 11 1.44772 11 2H12C12 0.895431 11.1046 0 10 0H6Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRemove);
export default __webpack_public_path__ + "static/media/imageRemove.2929f802abdfd1802a97ab9a4372b497.svg";
export { ForwardRef as ReactComponent };